import axiosInstance from './axiosInstance'

// Existing endpoints
export const getUsers = async () => {
  const res = await axiosInstance.get('/users')
  return res.data
}

export const getUserById = async (userId) => {
  const res = await axiosInstance.get(`/users/${userId}`)
  return res.data
}

export const updateUser = async (user) => {
  const res = await axiosInstance.put(`/users/${user.userId}`, user)
  return res.data
}

export const deleteUser = async (userId) => {
  const res = await axiosInstance.delete(`/users/${userId}`)
  return res.data
}

export const getLeaderboard = async (period = 'alltime', count = 10) => {
  const res = await axiosInstance.get('/users/leaderboard', { params: { period, count } })
  return res.data
}